// extracted by mini-css-extract-plugin
export default {"FormBody":"Body_FormBody__-Yu1I","OfferCard":"Body_OfferCard__jOX4t","btn_submit":"Body_btn_submit__2nYNb","Terms":"Body_Terms__ZesLL"};